import { __extends } from "tslib";
import React from 'react';
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    List.prototype.render = function () {
        var _a = this.props, _b = _a.component, component = _b === void 0 ? 'ul' : _b, className = _a.className, data = _a.data, keySelector = _a.keySelector, itemRenderer = _a.itemRenderer;
        var listProps = {
            className: className,
        };
        return React.createElement(component, listProps, data.map(function (datum, i) {
            var key = keySelector ? keySelector(datum) : i;
            var child = itemRenderer(datum);
            return (React.createElement(React.Fragment, { key: key }, React.cloneElement(child)));
        }));
    };
    List.defaultProps = {
        component: 'ul',
        className: undefined,
    };
    return List;
}(React.Component));
export { List };
//# sourceMappingURL=List.js.map